module.exports = __webpack_public_path__ + "static/media/invoicesIcon.c33a7f9a.svg";